import React, { createContext, useContext } from "react";

import { useCurrentPageType } from "shared/hooks";
import type { CustomQueryParameters } from "shared/types/gtm";

// TODO: use base link context for replacing all customQueryParameters in props
type ContextValue = {
  customQueryParameters?: CustomQueryParameters;
  linkTarget?: React.HTMLAttributeAnchorTarget;
};

type Props = {
  children: React.ReactNode;
  customQueryParameters?: Partial<CustomQueryParameters> & Pick<CustomQueryParameters, "module">;
  linkTarget?: React.HTMLAttributeAnchorTarget;
};

const BaseLinkContext = createContext<ContextValue>({
  customQueryParameters: undefined,
  linkTarget: undefined,
});

export const BaseLinkContextProvider: React.FunctionComponent<Props> = ({
  children,
  customQueryParameters,
  linkTarget,
}) => {
  const pageType = useCurrentPageType();

  return (
    <BaseLinkContext.Provider
      value={{
        customQueryParameters: {
          pgtype: pageType,
          ...customQueryParameters,
        },
        linkTarget,
      }}
    >
      {children}
    </BaseLinkContext.Provider>
  );
};

export const useBaseLinkContext = () => useContext(BaseLinkContext);
